import { Route, Routes } from "react-router-dom";
import AuthGuard from "./core/guards/AuthGuard.tsx";
import { type RouteDefinition } from "./shared/types/routes.ts";
import AuthCallback from "./features/auth-callback/AuthCallback.tsx";
import { homeRoutes } from "./features/home/home.routes.tsx";
import { profileRoutes } from "./features/profile/profile.routes.tsx";
import { usersRoutes } from "./features/users/users.routes.tsx";
import AppShell from "./shared/layout/AppShell.tsx";

const allRoutes: RouteDefinition[] = [...homeRoutes, ...usersRoutes, ...profileRoutes];

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/auth-callback" element={<AuthCallback />} />
      <Route
        element={
          <AuthGuard>
            <AppShell />
          </AuthGuard>
        }
      >
        {allRoutes.map((r) => (
          <Route key={r.path} path={r.path} element={r.element} />
        ))}
      </Route>
    </Routes>
  );
};

export default AppRoutes;
